export const basicDetail = [
  {
    name: "companyname",
    rule: {
      required: "Company Name is required",
    },
    label: "Company Name",
    type: "text",
  },
  {
    name: "companycode",
    rule: {
      required: "Company Code is required",
    },
    label: "Company Code",
    type: "text",
  },
  {
    name: "email",
    rule: {
      required: "Email is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
    label: "Email",
    type: "text",
  },
  {
    name: "phone",
    rule: {
      required: false,
    },
    label: "Phone",
    type: "text",
  },
  {
    name: "address1",
    rule: {
      required: false,
    },
    label: "Address",
    type: "text",
  },
  {
    name: "city",
    rule: {
      required: false,
    },
    label: "City",
    type: "text",
  },
  {
    name: "state",
    rule: {
      required: false,
    },
    label: "State",
    type: "text",
  },
  {
    name: "country",
    rule: {
      required: false,
    },
    label: "Country",
    type: "text",
  },
  {
    name: "zipcode",
    rule: {
      required: false,
    },
    label: "Zip Code",
    type: "text",
  },
  {
    name: "currency",
    rule: {
      required: false,
    },
    label: "Currency",
    type: "text",
  },
  {
    name: "url",
    rule: {
      required: false,
    },
    label: "Website URL",
    type: "text",
  },
  {
    name: "planType",
    rule: {
      required: false,
    },
    label: "Plan Type",
    type: "dropdown",
  },
  {
    name: "status",
    rule: {
      required: true,
    },
    label: "Status",
    type: "dropdown",
  },
];

// Fields only shown during company creation (for initial admin user)
export const createOnlyFields = [
  {
    name: "admin_username",
    rule: {
      required: "Admin Username is required",
    },
    label: "Admin Username",
    type: "text",
  },
  {
    name: "admin_email",
    rule: {
      required: "Admin Email is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
    label: "Admin Email",
    type: "text",
  },
];

export const statusDD = [
  { id: "Y", name: "Active" },
  { id: "N", name: "Inactive" },
];

export const planTypeDD = [
  { id: "BASIC", name: "Basic" },
  { id: "PREMIUM", name: "Premium" },
  { id: "ENTERPRISE", name: "Enterprise" },
];

export const editMode = [
  {
    name: "created_date",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Created Date",
    type: "text",
  },
  {
    name: "modified_date",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Modified Date",
    type: "text",
  },
];

export const CompaniesBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Company", path: "/company" },
];
